module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Bold.bbeb1eaa.svg";